import FontWeights from '../../common/fontWeight';
import UserHeader from '../../components/user/Header';
import Fontsizes from '../../common/fontSize';
import { Card, List, Avatar } from 'antd';
import { useCallback, useEffect, useState } from 'react';
import { PlayCircleOutlined } from '@ant-design/icons';
import { videoService } from '../../services/videoService';
import { message } from 'antd';
import ReactPlayer from 'react-player';

const Video: React.FC = () => {
    const [selectedVideo, setSelectedVideo] = useState<any>();
    const [videos, setVideos] = useState<any[]>([]);

    const fetchVideos = useCallback(async () => {
        try {
            const response = await videoService.getVideos({
                page: 1,
                pageSize: 1000
            });
            setVideos(response.data);
        } catch (error) {
            message.error('Không thể tải danh sách video');
        }
    }, []);

    useEffect(() => {
        fetchVideos();
    }, [fetchVideos]);

    return (
        <div style={{ fontWeight: FontWeights.normal }}>
            <UserHeader />
            <div className="container mx-auto px-4 mt-[120px]">
                <div className="flex flex-col md:flex-row gap-6">
                    {/* Left Column - Video List */}
                    <div className="md:w-1/3">
                        <Card title="Video List" className="sticky top-[120px] max-h-[calc(100vh-200px)] overflow-y-auto">
                            <List
                                itemLayout="horizontal"
                                dataSource={videos}
                                renderItem={(video) => (
                                    <List.Item
                                        className={`cursor-pointer hover:bg-gray-50 ${selectedVideo?.id === video.id ? 'bg-gray-100' : ''}`}
                                        onClick={() => setSelectedVideo(video)}
                                    >
                                        <List.Item.Meta
                                            avatar={
                                                <div className="relative">
                                                    <Avatar
                                                        icon={<PlayCircleOutlined />}
                                                        size={48}
                                                        className="bg-gray-200"
                                                    />
                                                </div>
                                            }
                                            title={<span style={{ fontSize: Fontsizes.sm }}>{video?.title}</span>}
                                            description={
                                                <span style={{ fontSize: Fontsizes.xs }}>
                                                    {video?.createdAt?.substring(0, 10)}
                                                </span>
                                            }
                                        />
                                    </List.Item>
                                )}
                            />
                        </Card>
                    </div>

                    {/* Right Column - Video Player and Details */}
                    {
                        selectedVideo ? <div className="md:w-2/3">
                            {/* Video Title Section */}
                            <div className="mb-6">
                                <h1 className="text-2xl font-bold mb-2">{selectedVideo?.title}</h1>
                                <p className="text-gray-600" style={{ fontSize: Fontsizes.sm }}>
                                    Published on {selectedVideo?.createdAt?.substring(0, 10)}
                                </p>
                            </div>

                            {/* Video Player Section */}
                            <div className="mb-8">
                                <div className="aspect-w-16 aspect-h-9 bg-black rounded-lg overflow-hidden"
                                    onContextMenu={(e) => e.preventDefault()}
                                    style={{ userSelect: 'none' }}>
                                    <ReactPlayer
                                        url={selectedVideo?.linkVideo}
                                        width="100%"
                                        height="500px"
                                        controls={true}
                                        playing={false}
                                        config={{
                                            file: {
                                                attributes: {
                                                    controlsList: 'nodownload',
                                                    onContextMenu: (e: any) => e.preventDefault()
                                                }
                                            }
                                        }}
                                    />
                                </div>
                            </div>

                            {/* Video Information Section */}
                            <div className="grid grid-cols-1 gap-6">
                                <Card title="Content" className="mb-6">
                                    <p style={{
                                        fontSize: Fontsizes.sm,
                                        whiteSpace: 'pre-line',
                                        maxHeight: '400px',
                                        overflow: 'auto',
                                        userSelect: 'none'
                                    }}
                                        onContextMenu={(e) => e.preventDefault()}>
                                        {selectedVideo?.content}
                                    </p>
                                </Card>
                            </div>
                        </div> : <div className="md:w-2/3">
                            <div className="flex items-center justify-center h-full">
                                <div className="text-center">
                                    <h1 className="text-2xl font-bold mb-4">No video selected</h1>
                                    <p className="text-gray-600" style={{ fontSize: Fontsizes.sm }}>
                                        Please select a video from the list.
                                    </p>
                                </div>
                            </div>
                        </div>
                    }
                </div>
            </div>
        </div>
    );
}

export default Video;
